/**
 * These are special path names we use to track
 * analytics from promotions - when a user visits
 * /slug, they get redirected to /?ref=slug and
 * we record a tracking event
 */

export const PROMO_SLUGS = ['thegreendeveloper', 'holistic', 'sara', 'vicky', 'colorsofchloe', 'colors'];
